import React from "react";
import Link from "next/link";
import FooterAddress from "./FooterAddress";
import { RiPhoneLine, RiMailLine, RiMapPinLine } from "@remixicon/react";
import Image from "next/image";
// const ADDRESS_MAPS = {
//   "West Sikkim": {
//     label: "West Sikkim",
//     iframe: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3209.7412226266897!2d88.24171147490695!3d27.254308045328372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e6832eeb4827b7%3A0xd5a6c3edc87e837b!2sMedhavi%20Skills%20University%2C%20Bermiok%20Campus!5e1!3m2!1sen!2sin!4v1767941445074!5m2!1sen!2sin`
//   },
//   "East Sikkim": {
//     label: "East Sikkim",
//     iframe: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3210.192084406187!2d88.51195137490645!3d27.238680346007285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e6a1c3e1baaaab%3A0x6e38bf86f7e3420b!2sMedhavi%20Skills%20University%2C%20Sikkim!5e1!3m2!1sen!2sin!4v1767941551997!5m2!1sen!2sin`
//   }
// };

export default function ContactWithCopyright({
  footerData,
  footerCopyright,
  footerAddress,
  footerMobile,
  footerEmail,
}) {

  return (
    <>
      {/* CONTACT BAR */}
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto py-10">
        <div className="mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Phone */}
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 border border-white/20 flex items-center justify-center rounded-md">
              <RiPhoneLine
                size={22}
                className="text-white"
                aria-hidden="true"
              />
            </div>
            <div>
              {/* <p className="footer-link text-gray-300">Contact No:</p> */}
              <a
                href={`tel:${footerMobile}`}
                className="footer-link underline text-white cursor-pointer address-details"
              >
                {footerMobile}
              </a>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 border border-white/20 flex items-center justify-center rounded-md">
              <RiMailLine size={22} className="text-white" aria-hidden="true" />
            </div>
            <div>
              {/* <p className="footer-link text-gray-300">Email:</p> */}
              <a
                href={` mailto:${footerEmail}`}
                className="footer-link text-white underline cursor-pointer address-details"
              >
                {footerEmail}
              </a>
            </div>
          </div>

          {/* Location */}
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 border border-white/20 flex items-center justify-center rounded-md">
              <RiMapPinLine
                size={22}
                className="text-white"
                aria-hidden="true"
              />
            </div>
            <div>
              <FooterAddress footerAddress={footerAddress} />
              {/* <p className="footer-link text-gray-300">Location:</p> */}
              {/* <p className="footer-link text-white  cursor-pointer address-details">{footerAddress}</p> */}
            </div>
          </div>
          <div className="flex gap-4 text-2xl">
            {footerData.socialLinks.map(({ Icon, label, url }) => (
              <Link
                key={label}
                href={url}
                target="_blank"
                rel="noreferrer"
                aria-label={`Visit our ${label} page`}
                prefetch={false}
                className="w-10 h-10 flex items-center justify-center border border-white/20  
               hover:bg-white/20 transition cursor-pointer"
              >
                <Icon className="text-white" aria-hidden="true" />
              </Link>
            ))}
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="mx-auto mt-8">
          <p className="footer-link text-white/50 text-sm">{footerCopyright}</p>
          <a
            href="https://www.dmca.com/r/g87jyw1"
            title="DMCA Protection Status"
            target="_blank"
            rel="noopener noreferrer"
            className="dmca-badge"
            prefetch="false"
          >
            <Image
              src="https://images.dmca.com/Badges/dmca-badge-w100-5x1-06.png?ID=75d0aa0b-6520-4b1b-b794-a5c856f4407b"
              alt="DMCA Protected"
              width={100}
              height={20}
              prefetch="false"
            />
          </a>
        </div>
      </div>
    </>
  );
}
